<mat-label class="subHeading">City<span class="star">*</span></mat-label>
<mat-select class="city" placeholder="All">
    <mat-option *ngFor="let cityObj of cities" [value]="cityObj.rb_id">
        {{cityObj.city_name}}
    </mat-option>
</mat-select>